var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 8.04692V8.66692C14.9982 11.6194 13.0547 14.2191 10.2234 15.0562C7.39215 15.8933 4.34747 14.7685 2.74051 12.2916C1.13355 9.8148 1.34712 6.57601 3.26539 4.33163C5.18366 2.08725 8.34968 1.37193 11.0465 2.57358",
    stroke: "#979EBE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6668 2.66699L8.3335 10.0003L6.3335 8.00033",
    stroke: "#979EBE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleLight);
export default __webpack_public_path__ + "static/media/check-circle-light.122f171d56b8c1ceb21b342b1cc0f504.svg";
export { ForwardRef as ReactComponent };